import React from 'react';
import Immutable from 'immutable';
import { createStore, applyMiddleware, bindActionCreators as reduxBindActionCreators  } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import createLogger from 'redux-logger';
import AppReducer from './app.reducer.jsx';
import questionnaireSaga from './app.sagas.jsx';

const loggerMiddleware = createLogger({
    predicate: () => {
        /* eslint-disable no-process-env */
        const isNotProduction = 'production' !== process.env.NODE_ENV;
        const isNotTest = 'test' !== process.env.NODE_ENV;
        /* eslint-enable no-process-env */
        return isNotProduction && isNotTest;
    },
    stateTransformer: (state) => {
        return Immutable.fromJS(state).toJS();
    }
});
const sagaMiddleware = createSagaMiddleware(questionnaireSaga);
const middlewares = [ sagaMiddleware, thunkMiddleware ];
if ('production' !== process.env.NODE_ENV) {
    middlewares.push(loggerMiddleware);
    //window.Perf = require('react-addons-perf');
    //window.Perf.start();
}
const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);
export const store = createStoreWithMiddleware(AppReducer);
export const dispatch = store.dispatch;

export function bindActionCreators(actionCreator) {
    if ('function' !== typeof actionCreator) { throw new TypeError('Action creator must be a function'); }
    return reduxBindActionCreators(actionCreator, dispatch);
}

if ('undefined' !== typeof window) {
    window.getState = function getState(AS_OBJECT = false) {
        /*
         * As root-level of state and some other part are store as plain object, and other part as Immutable
         * We need to completely cast to to Immutable, and then back to plain object.
         * */
        const state = Immutable.fromJS(store.getState()).toJS();
        if (AS_OBJECT) { return state; }
        return JSON.stringify(state);
    };
}
